import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Users, MapPin, UsersRound,
  CalendarDays, Briefcase, LogOut, ChevronRight,
  UserRoundCogIcon
} from 'lucide-react';

const NAV_ITEMS = [
  { label: 'Dashboard', icon: LayoutDashboard, path: '/me/admin'          },
  { label: 'Clients',   icon: Users,           path: '/me/admin/clients'  },
  { label: 'Sites',     icon: MapPin,           path: '/me/admin/sites'    },
  { label: 'Teams',     icon: UsersRound,       path: '/me/admin/teams'    },
  { label: 'Users',     icon: UserRoundCogIcon,          path: '/me/admin/users'    },
  { label: 'Schedule',  icon: CalendarDays,     path: '/me/admin/schedule' },
  { label: 'Jobs',      icon: Briefcase,        path: '/me/admin/jobs'     },
];

const MideastNavigation = () => {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('mideast_token');
    localStorage.removeItem('mideast_user');
    navigate('/me-login');
  };

  return (
    <nav
      className="md-sidebar"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ '--expanded': hovered ? '1' : '0' }}
    >
      {/* Logo */}
      <div className="md-sidebar-logo">
        <div className="md-logo-icon">N</div>
        <div className="md-logo-text">
          <span className="md-logo-name">NOVAA</span>
          <span className="md-logo-sub">Mideast</span>
        </div>
      </div>

      {/* Divider */}
      <div className="md-sidebar-divider"/>

      {/* Nav items */}
      <ul className="md-nav-list">
        {NAV_ITEMS.map(({ label, icon: Icon, path }) => (
          <li key={path}>
            <NavLink
              to={path}
              end={path === '/mideast/admin'}
              className={({ isActive }) =>
                `md-nav-item${isActive ? ' md-nav-item--active' : ''}`
              }
            >
              <span className="md-nav-icon"><Icon size={17} strokeWidth={1.8}/></span>
              <span className="md-nav-label">{label}</span>
              <span className="md-nav-arrow"><ChevronRight size={12}/></span>
            </NavLink>
          </li>
        ))}
      </ul>

      {/* Bottom: logout */}
      <div className="md-sidebar-bottom">
        <div className="md-sidebar-divider"/>
        <button className="md-nav-item md-nav-logout" onClick={handleLogout}>
          <span className="md-nav-icon"><LogOut size={17} strokeWidth={1.8}/></span>
          <span className="md-nav-label">Sign Out</span>
        </button>
      </div>
    </nav>
  );
};

export default MideastNavigation;